import React from 'react';
import ResourceGridView from './../../../components/grid/ResourceGridView';
import {useStore} from "../../../context";

import ResourceUpdate from "./ExpenseTypeUpdate";
import ResourceCreate from "./ExpenseTypeCreate";
import {observer} from "mobx-react";
import {IExpenseModel} from "../../../utils/models";
import StandalonePopover from "../../../components/ui/StandalonePopover";

const ResourceGrid = observer(() => {

    const {genericResourceStore} = useStore();

    const canEdit = true;

    genericResourceStore.configure('/api/expense_types', 'Expense type')


    return (
        <div className='dashboard'>
            {genericResourceStore.place === 'create' &&
            <StandalonePopover title={'Create'} closePopover={() => genericResourceStore.changePlace('grid')}>
                <ResourceCreate sharedGridResourceCollectionStore={genericResourceStore}/>
            </StandalonePopover>}
            {genericResourceStore.place === 'update' &&
            <StandalonePopover size={"bd"}
                               title={`${genericResourceStore.label} #${genericResourceStore.currentResourceId} update`}
                               closePopover={() => genericResourceStore.changePlace('grid')}>
                <ResourceUpdate canRemove={canEdit} sharedGridResourceCollectionStore={genericResourceStore}/>
            </StandalonePopover>}
            <ResourceGridView<IExpenseModel>
                columns={[
                    {
                        name: 'id',
                        value: (item) => item['@id'].split('/').reverse()[0],
                    },
                    {
                        name: 'label',
                        value: (item) => item.label,
                    },
                ]}
                onRowClick={(item) => {
                    genericResourceStore.changePlace('update', item)
                }}


                gridResource={genericResourceStore}
            />
        </div>
    );
})


export default ResourceGrid;
